import { render, staticRenderFns } from "./EmpBasic_BAK.vue?vue&type=template&id=2dff1852"
import script from "./EmpBasic_BAK.vue?vue&type=script&lang=js"
export * from "./EmpBasic_BAK.vue?vue&type=script&lang=js"
import style0 from "./EmpBasic_BAK.vue?vue&type=style&index=0&id=2dff1852&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports